import './button.scss';

import { Button } from './button';

export const ApplyBtn = ({ onClick }: { onClick: VoidFunction }) => {
	return (
		<Button style={{ width: '100px' }} onClick={onClick}>
			Добавить
		</Button>
	);
};
